import {
  RELATED_VIDEOS_REQUEST,
  RELATED_VIDEOS_SUCCESS,
  RELATED_VIDEOS_RESET,
  RELATED_VIDEOS_IQS_REQUEST,
  RELATED_VIDEOS_IQS_SUCCESS,
} from './actions';

const initialState = {
  pageNumber: 1,
  perPage: null,
  pageSize: null,
  pageCursor: null,
  total: null,
  videos: [],
  loading: true,
};

export const relatedVideosReducer = (state = initialState, action) => {
  switch (action.type) {
    case RELATED_VIDEOS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case RELATED_VIDEOS_SUCCESS:
      return {
        ...action.payload,
        loading: false,
      };

    case RELATED_VIDEOS_IQS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case RELATED_VIDEOS_IQS_SUCCESS:
      return {
        ...action.payload,
        loading: false,
      };

    case RELATED_VIDEOS_RESET:
      return initialState;

    default:
      return state;
  }
};
